import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const BoxStyled = styled(Box)({
  padding: '8px 16px',
  backgroundColor: '#FAFAFA',
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  borderRadius: '4px',
  border: '1px solid #E0E0E0',
});
